import { render, staticRenderFns } from "./noAuthModal.vue?vue&type=template&id=a8a68fe4&scoped=true"
import script from "./noAuthModal.vue?vue&type=script&lang=js"
export * from "./noAuthModal.vue?vue&type=script&lang=js"
import style0 from "./noAuthModal.vue?vue&type=style&index=0&id=a8a68fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a68fe4",
  null
  
)

export default component.exports